<template>
  <div class="billing-page">
    <el-card class="info-card">
      <h2 class="title">Подписка</h2>
      <div class="subscription-info">
        <div class="label">Ваш текущий статус:</div>
        <div
          :class="subscriptionStatusClass"
          class="value"
        >
          {{ subscriptionStatusText }}
        </div>
      </div>
    </el-card>

    <div class="container-fluid">
      <div class="row">
        <div class="col-8">
          <el-card class="plans-card">
            <template #header>
              Выберите период продления
            </template>
            <div class="plans">
              <div
                v-for="plan in plans"
                :key="plan.id"
                class="plan"
                :class="{ active: selectedPlan === plan.id }"
                @click="selectPlan(plan.id)"
              >
                <div class="plan-title">{{ plan.label }}</div>
                <div class="plan-price">{{ formatPrice(plan.price) }} ₽</div>
                <div class="plan-discount" v-if="plan.discount">
                  Скидка {{ plan.discount }}%
                </div>
                <div class="plan-discount" v-else>&nbsp;</div>
              </div>
            </div>
          </el-card>
        </div>
        <div class="col-4">
          <el-card class="summary-card">
            <template #header>К оплате</template>
            <div class="plans">
              <div class="col-12">
                <span style="margin-right: 10px">Период:</span>
                <span class="summary-value">{{ activePlan.label }}</span>
              </div>
              <div class="col-12">
                <span class="total summary-value">{{ formatPrice(activePlan.price) }} ₽</span>
              </div>
            </div>
            <div class="summary-footer">
              <el-button
                  type="primary"
                  class="pay-btn"
                  :loading="isLoading"
                  :disabled="isLoading"
                  @click="createInvoice"
              >
                Оформить и оплатить
              </el-button>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: "BillingPage",
  data() {
    return {
      billing: {
        status: 'demo',
        expires_at: null
      },
      selectedPlan: 1,
      isLoading: false,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('billing', ['plans']),
    activePlan() {
      if (!this.plans || this.plans.length === 0) {
        return { id: null, label: '', price: 0, discount: 0 };
      }
      return this.plans.find(p => p.id === this.selectedPlan) || this.plans[0];
    },
    subscriptionStatusText() {
      if (!this.user || !this.user.subscription) return '—';

      const sub = this.user.subscription;

      if (sub.status === 'expired') {
        const date = sub.paid_until
          ? new Date(sub.paid_until * 1000).toLocaleDateString('ru-RU')
          : '';
        return `Подписка истекла ${date}`;
      }

      if (sub.status === 'demo') {
        return `Демо (осталось ${sub.days_left} дней)`;
      }

      const date = sub.paid_until
        ? new Date(sub.paid_until * 1000).toLocaleDateString('ru-RU')
        : '';
      return `Активная подписка (до ${date})`;
    },
    subscriptionStatusClass() {
      if (!this.user || !this.user.subscription) return '';
      const sub = this.user.subscription;

      if (sub.status === 'expired') return 'status-expired';
      if (sub.status === 'demo') return 'status-demo';

      // active
      if (sub.days_left !== undefined && sub.days_left <= 7) return 'status-warning';

      return 'status-active';
    }
  },
  async mounted() {
    await this.$store.dispatch("billing/loadPlans");
  },
  methods: {
    selectPlan(id) {
      this.selectedPlan = id;
    },
    async createInvoice() {
      if (this.isLoading) return;
      this.isLoading = true;

      try {
        const res = await this.$store.dispatch("billing/createInvoice", {
          plan_id: this.activePlan.id
        });
        console.log("Billing: response from backend =", res);
        // --- auto form submit to Modulbank ---
        if (res && res.form_url && res.fields) {
          const form = document.createElement('form');
          console.log("Billing: created form element =", form);
          console.log("Billing: form action =", res.form_url);
          form.method = 'POST';
          form.action = res.form_url;

          Object.keys(res.fields).forEach(key => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = res.fields[key];
            form.appendChild(input);
            console.log("Billing: appended field", key, "=", res.fields[key]);
          });

          console.log("Billing: appending form to body…");
          document.body.appendChild(form);
          console.log("Billing: submitting form now…");
          form.submit();
          return;
        }
      } catch (e) {
        console.error("Invoice error:", e);
      } finally {
        this.isLoading = false;
      }
    },
    formatPrice(value) {
      return Number(value).toLocaleString('ru-RU');
    }
  }
}
</script>
<style scoped>
.billing-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  overflow-y: auto;
  padding: 24px 18px 28px;
  background:
    radial-gradient(circle at top left, rgba(22, 61, 124, 0.28), transparent 34%),
    linear-gradient(180deg, #091325 0%, #07111f 100%);
}

.info-card, .plans-card, .summary-card {
  background: linear-gradient(180deg, rgba(10, 26, 52, 0.96), rgba(7, 18, 36, 0.94));
  border: 1px solid rgba(110, 146, 214, 0.18);
  border-radius: 24px;
  box-shadow: 0 24px 48px rgba(2, 8, 18, 0.34);
}

.billing-page :deep(.el-card__header),
.billing-page :deep(.el-card__body) {
  background: transparent;
}

.billing-page :deep(.el-card__header) {
  color: #f5f9ff;
  font-family: "Oswald", sans-serif;
  font-size: 24px;
  font-weight: 500;
}

.title, .section-title {
  color: #f5f9ff;
  margin-bottom: 10px;
}

.subscription-info .label {
  color: rgba(174, 194, 230, 0.68);
}

.subscription-info .value {
  font-size: 18px;
}

.plans {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
}

.plan {
  width: 180px;
  padding: 15px;
  border: 1px solid rgba(110, 146, 214, 0.14);
  background: rgba(8, 23, 47, 0.92);
  cursor: pointer;
  color: #d7e7ff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.plan.active {
  border-color: #00c3fe;
  background: rgba(0, 195, 254, 0.08);
  color: #eef5ff;
}

.plan-title {
  font-weight: bold;
  margin-bottom: 5px;
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plan-price {
  font-size: 20px;
  margin-bottom: 5px;
  font-weight: 700;
  color: var(--ui-color-brand-accent);
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}


.plan-discount {
  color: #00c3fe;
  font-size: 14px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plans .col-12,
.summary-value {
  color: #d7e7ff;
}


.plans-card {
  width: 100%;
  display: block;
}

.summary-card {
  width: 100%;
  min-height: 180px;
  display: block;
}

.summary-block .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: var(--ui-color-text-heading);
}

.total-row {
  margin-top: 5px;
}

.total {
  font-size: 26px;
  color: var(--ui-color-brand-accent);
}

.summary-value {
  font-weight: 700;
}

.summary-footer {
  margin-top: 10px;
  text-align: center;
}

.pay-btn {
  width: 250px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #00c3fe, #2b7cff);
  box-shadow: 0 16px 32px rgba(0, 123, 255, 0.2);
}

.status-expired {
  color: #dc2626; /* red */
}
.status-warning {
  color: #f97316; /* orange */
}
.status-active {
  color: #16a34a; /* green */
}
.status-demo {
  color: #f97316; /* orange */
}

@media (max-width: 768px) {
  .billing-page {
    padding: 16px 12px 22px;
  }

  .billing-page .row {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .billing-page .col-8,
  .billing-page .col-4 {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
  }

  .pay-btn {
    width: 100%;
  }

  .billing-page :deep(.el-card__header) {
    font-size: 18px;
  }

  .plan {
    width: min(160px, 100%);
    padding: 12px;
  }

  .plan-title {
    min-height: 22px;
  }

  .plan-price {
    font-size: 16px;
    min-height: 24px;
  }

  .plan-discount {
    font-size: 12px;
    height: 18px;
  }
}
</style>
